import styled from "@emotion/styled";
import { Card, Col, Row, Tabs, Typography, Input } from "antd";
import { goBack } from "assets/icons/index";
import { useNavigate } from "react-router-dom";
import ProductOnSale from "./ProductOnSale";
import { useGetProductList, useGetProductListApprove, useGetProductListInActive } from "hooks/useProduct";
import ProductApprove from "./ProductApprove";
import { useState, useMemo } from "react";
import { GetProductListResponse } from "services/interface";

const ManageProduct = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const {
    data: ProductListActive,
    isLoading: loadingProductListActive,
    refetch: refectchProductListActive,
  } = useGetProductList({ is_active: true, is_approve: true });
  const {
    data: ProductListInActive,
    isLoading: loadingProductListInActive,
    refetch: refectchProductListInActive,
  } = useGetProductListInActive({ is_active: false, is_approve: true });

  const {
    data: ProductListApprove,
    isLoading: loadingProductListApprove,
    refetch: refectchProductListApprove,
  } = useGetProductListApprove({ is_approve: false });

  // ฟังก์ชันกรองสินค้าตาม search term
  const filterProducts = (data: GetProductListResponse | undefined, term: string): GetProductListResponse | undefined => {
    if (!data || !term.trim()) {
      return data;
    }
    
    const filteredProducts = data.products.filter((product) => {
      const searchLower = term.toLowerCase();
      return (
        product?.name?.toLowerCase().includes(searchLower) ||
        product?.description?.toLowerCase().includes(searchLower) ||
        product?.category?.toLowerCase().includes(searchLower)
      );
    });

    return {
      ...data,
      products: filteredProducts,
    };
  };

  // กรองข้อมูลสินค้าตาม search term
  const filteredProductListActive = useMemo(
    () => filterProducts(ProductListActive, searchTerm),
    [ProductListActive, searchTerm]
  );

  const filteredProductListInActive = useMemo(
    () => filterProducts(ProductListInActive, searchTerm),
    [ProductListInActive, searchTerm]
  );

  const filteredProductListApprove = useMemo(
    () => filterProducts(ProductListApprove, searchTerm),
    [ProductListApprove, searchTerm]
  );

  const items = [
    {
      label: `ขายอยู่ (${searchTerm ? filteredProductListActive?.products.length ?? 0 : ProductListActive?.products.length ?? 0})`,
      key: "1",
      children: (
        <ProductOnSale
          isLoading={loadingProductListActive}
          data={filteredProductListActive}
          refetch={refectchProductListActive}
          refetchTo={refectchProductListInActive}
        />
      ),
    },
    // {
    //   label: `สินค้าหมด (0)`,
    //   key: "2",
    //   children: <></>,
    // },
    {
      label: `กำลังตรวจสอบ (${searchTerm ? filteredProductListApprove?.products.length ?? 0 : ProductListApprove?.products.length ?? 0})`,
      key: "3",
      children: (
        <>
          <ProductApprove
            isLoading={loadingProductListApprove}
            data={filteredProductListApprove}
            refetch={refectchProductListApprove}
          />
        </>
      ),
    },
    // {
    //   label: `รอแก้ไข (0)`,
    //   key: "4",
    //   children: <></>,
    // },
    {
      label: `ยังไม่เปิดการขาย (${searchTerm ? filteredProductListInActive?.products.length ?? 0 : ProductListInActive?.products.length ?? 0})`,
      key: "5",
      children: (
        <>
          <ProductOnSale
            isLoading={loadingProductListInActive}
            data={filteredProductListInActive}
            refetch={refectchProductListInActive}
            refetchTo={refectchProductListActive}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>จัดการสินค้า</Typography.Title>
              <RightIconWrapper>
                <Input
                  placeholder="ค้นหาสินค้า"
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ width: 200 }}
                  allowClear
                />
              </RightIconWrapper>
            </HeaderTabs>
            <>
              <Tabs
                defaultActiveKey="1"
                style={{ height: "100%" }}
                items={items}
              />
            </>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ManageProduct;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
